exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#bio[data-v-03a6a564],\n#summary[data-v-03a6a564],\n.card + .card[data-v-03a6a564] {\n  margin-top: 2rem;\n}", ""]);

// exports
